import type { Link, PhrasingContent, Root } from 'mdast';

import type { CommitReferenceMatch, CommitReferenceOptions } from './commit-references';

import { buildCommitUrl, findCommitReferences } from './commit-references';
import { linkifyMarkdownText, replaceTextReferences } from './text-references';

/** Links bare commit SHAs to the commit on GitHub. */
export default function remarkCommitReferences(options: CommitReferenceOptions) {
  return (tree: Root): void => {
    linkifyMarkdownText(tree, (node) =>
      replaceTextReferences<CommitReferenceMatch, PhrasingContent>(
        node.value,
        findCommitReferences(node.value),
        (value) => ({ type: 'text', value }),
        (match): Link => ({
          type: 'link',
          url: buildCommitUrl(options, match.sha),
          children: [{ type: 'text', value: match.sha }],
        }),
      ),
    );
  };
}
